import i18next from 'i18next';

import { RequestAcceptanceStatus } from '../common/model/enumerations/requestAcceptanceStatus.model';
import { getKeyByValue } from './enum.utils';

export const getLocalizedText = (i18n: i18next.i18n, key: string): string => {
  return i18n.t(`enums.requestAcceptanceStatus.${key}`);
};

export const getLocalizedTextByValue = (i18n: i18next.i18n, state: number): string => {
  const key = getKeyByValue(RequestAcceptanceStatus, state);
  if (!key) {
    return '';
  }
  return getLocalizedText(i18n, key);
};

export const getIconCss = (requestAcceptanceStatus: number): string => {
  switch (requestAcceptanceStatus) {
    case RequestAcceptanceStatus.OK:
      return 'icon icon-request-acceptance-ok';
    case RequestAcceptanceStatus.KO:
      return 'icon icon-request-acceptance-ko';
    default:
      return '';
  }
};
